import { render, staticRenderFns } from "./QuestionnaireSelector.vue?vue&type=template&id=9836ccce&scoped=true&"
import script from "./QuestionnaireSelector.vue?vue&type=script&lang=js&"
export * from "./QuestionnaireSelector.vue?vue&type=script&lang=js&"
import style0 from "./QuestionnaireSelector.vue?vue&type=style&index=0&id=9836ccce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9836ccce",
  null
  
)

export default component.exports